import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'

import type { TypeParams } from './types'

export default ec.associations.create<TypeParams>(function (occupant) {
  const { employeeIds } = occupant as FlattenUnion<typeof occupant>
  this.select({
    collection: ec.Name.Predefined.SpaceEmployee,
    ids: employeeIds ?? [],
    update: (
      updatedEntity: typeof occupant,
      updatedIds: readonly ec.models.EntityId[],
    ) => {
      const _updatedEntity = updatedEntity as FlattenUnion<typeof updatedEntity>
      _updatedEntity.employeeIds = updatedIds.map(id =>
        TypeAsserter.validateButJustWarn(
          id,
          ents.extra.space.Employee.Id.assertIsId,
        ),
      )
    },
  })
})
